import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import IconBKCrownCard from 'components/icons/bk-crown-card';

export default (props: IBaseProps) => <IconBKCrownCard {...props} />;
